export default "__VITE_PUBLIC_ASSET__11142ffa__"